module.exports = __webpack_public_path__ + "img/Millennium.7e918bce.png";